<ng-container *ngIf="countertop$ | async"></ng-container>

<div class="flex flex-col items-stretch gap-4 mb-4">
  <div class="flex flex-row space-x-2">
    <csl-materials
      class="flex-1"
      [disabled]="disabled"
      [showMaterialsPrice]="showMaterialsPrice"
      [currencySymbol]="currencySymbol"
      [postformingGroups]="postformingGroups"
      [showQuantityInStock]="showQuantityInStock">
    </csl-materials>

    <countertop-type-select class="flex-1" [panelConnectors]="panelConnectors"></countertop-type-select>
  </div>

  <ng-container *ngIf="_countertop">
    <csl-sizes [disabled]="disabled" class="-mb-3" (valid)="valid.next($event)"></csl-sizes>
  </ng-container>

  <ng-content #actions></ng-content>
</div>

<mat-accordion *ngIf="_countertop">
  <mat-expansion-panel [ngClass]="{ hidden: !showFasteners }" [disabled]="!isMaterialSelected">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row space-x-4 justify-between">
        <div i18n>Присадка</div>
        <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-divider> </mat-divider>

    <csl-fasteners [disabled]="disabled"></csl-fasteners>
  </mat-expansion-panel>

  <mat-expansion-panel [ngClass]="{ hidden: !showEdgeBanding }" [disabled]="!isMaterialSelected">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row space-x-4 justify-between">
        <div i18n>Облицовка торца</div>
        <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <csl-edge-banding
      [disabled]="disabled"
      [showQuantityInStock]="showQuantityInStock"
      (selectionChange)="edgeBandingSelectionChange.emit($event)"></csl-edge-banding>
  </mat-expansion-panel>

  <mat-expansion-panel [ngClass]="{ hidden: !showFaceBanding }" [disabled]="!isMaterialSelected">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row space-x-4 justify-between">
        <div i18n>Облицовка пласти</div>
        <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <csl-face-banding [disabled]="disabled" [showQuantityInStock]="showQuantityInStock"></csl-face-banding>
  </mat-expansion-panel>

  <mat-expansion-panel [ngClass]="{ hidden: !showSlots }" [disabled]="!isMaterialSelected">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row space-x-4 justify-between">
        <div i18n>Пазы</div>
        <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <csl-slots [disabled]="disabled" (selectionChange)="slotSelectionChange.emit($event)"></csl-slots>
  </mat-expansion-panel>

  <mat-expansion-panel [ngClass]="{ hidden: !showCutouts }" [disabled]="!isMaterialSelected">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row space-x-4 justify-between">
        <div i18n>Вырезы</div>
        <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-divider> </mat-divider>

    <csl-cutouts [disabled]="disabled"></csl-cutouts>
  </mat-expansion-panel>

  <mat-expansion-panel [disabled]="!isMaterialSelected">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex flex-row space-x-4 justify-between">
        <div i18n>Соединение частей</div>
        <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-divider> </mat-divider>

    <csl-panels-joint [disabled]="!isMaterialSelected"></csl-panels-joint>
  </mat-expansion-panel>
</mat-accordion>
